module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }